import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import CarTagView from "../../../../../components/CarTag";
import CarTimerIcon from "../../../../../../media/images/icons/car-timer";
import profileImage from "../../../../../../media/images/profileImage.png";

export default function UserInfo() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        //   border: "1px solid gray",
        borderRadius: "12px",
        display: "flex",
        padding: "8px 4px",
        alignItems: "center",
        justifyContent: "space-between",
        // gap: "8px",
        boxShadow: "4px 4px 8px 4px rgba(0, 0, 0, 0.10)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <img
          style={{
            width: "30px",
            borderRadius: "50%",
          }}
          src={profileImage}
          alt=""
        />
        <Typography
          sx={{
            fontWeight: "600",
          }}
          noWrap
        >
          رضا یعقوبی‌فریان پور
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <CarTagView />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "4px",
            borderRadius: "8px",
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
          }}
        >
          <CarTimerIcon color={theme.palette.textColor.main} />

          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "600",
            }}
            noWrap
          >
            بار فعالی ندارید
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
